import type { IHttpClient } from '@wix/yoshi-flow-editor';
import { getMenu, queryMenus } from '@wix/ambassador-restaurants-menus-v1-menu/http';
import { SortOrder } from '@wix/ambassador-restaurants-menus-v1-menu/types';
import type { MenuTpa } from '../types/menusTypes';
import type { ErrorHandlerPublicAPI } from '@wix/error-handler';

export class MenusClient {
  constructor(private httpClient: IHttpClient, private errorHandler: ErrorHandlerPublicAPI) {}

  fetchVisibleMenus = async (menuIds: string[] = []): Promise<{ menus: MenuTpa[] }> => {
    const { withErrorHandler, getResolvedError } = this.errorHandler;
    try {
      const { data } = await withErrorHandler(
        () =>
          this.httpClient.request(
            queryMenus({
              query: {
                filter: { id: { $in: menuIds }, visible: true },
                sort: [
                  {
                    fieldName: 'createdDate',
                    order: SortOrder.ASC,
                  },
                ],
              },
            })
          ),
        { errorCodesMap: {} }
      );

      return { menus: data.menus ?? [] };
    } catch (e: unknown) {
      const error = getResolvedError(e);
      console.error(error);
      return { menus: [] };
    }
  };

  getMenuById = async (menuId: string) => {
    const { withErrorHandler, getResolvedError } = this.errorHandler;
    try {
      const { data } = await withErrorHandler(() => this.httpClient.request(getMenu({ menuId })), {
        errorCodesMap: {},
      });
      return data;
    } catch (e: unknown) {
      const error = getResolvedError(e);
      console.error(error);
      return {};
    }
  };
}
